<template>
  <div>
    <h3>付款信息</h3>
    <el-table :data="infos" style="width: 100%">
      <el-table-column prop="serialNum" label="交易流水号"></el-table-column>
      <el-table-column prop="name" label="付款方名称"></el-table-column>
      <el-table-column prop="dateTimes" label="日期" width="85"></el-table-column>
      <el-table-column prop="amount" label="金额"></el-table-column>
      <el-table-column prop="shopNum" label="商铺编号"></el-table-column>
      <el-table-column prop="reconciled" label="已对账金额"></el-table-column>
      <el-table-column prop="surplus" label="未对账金额"></el-table-column>
      <!-- <el-table-column prop="state" label="对账状态">
				<template slot-scope="{row}">
					{{ row.state == 1 ? '未对账' : '已对账' }}
				</template>
			</el-table-column> -->
    </el-table>
    <el-form
      :inline="true"
      style="margin-top: 20px"
      :model="selectForm"
      class="demo-form-inline"
    >
      <div class="flex sb">
        <!-- <div>
					<el-form-item label="商铺号">
						<el-input v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input>
					</el-form-item>
					<el-form-item label="缴费类型">
						<el-select v-model="selectForm.type">
							<el-option label="租金" value="1"></el-option>
							<el-option label="水费" value="2"></el-option>
							<el-option label="电费" value="3"></el-option>
							<el-option label="物业费" value="4"></el-option>
							<el-option label="其他" value="5"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始时间">
						<el-date-picker v-model="selectForm.startTime" type="date" placeholder="开始时间"
							style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间">
						<el-date-picker v-model="selectForm.endTime" type="date" placeholder="结束时间"
							style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
				</div> -->
      </div>
    </el-form>
    <h3>账单</h3>
    <el-table
      :data="formDate"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      max-height="300"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="shopNum" label="商铺号"></el-table-column>
      <el-table-column prop="shopName" label="商铺名称"></el-table-column>
      <el-table-column prop="type" label="缴费类型"></el-table-column>
      <el-table-column prop="amount" label="应缴金额"></el-table-column>
      <el-table-column prop="state" label="缴费状态"></el-table-column>
      <el-table-column prop="time" label="账单年月">
        <template slot-scope="scope">
          <span>{{
            scope.row.time.split("-")[0] + "-" + scope.row.time.split("-")[1]
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-input v-model="shopRemark" placeholder="请输入备注" type="textarea"></el-input>
    <div
      style="
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        margin-right: 50px;
        margin-left: 20px;
      "
    >
      <div>选中：{{ paymentBillVos.length }}/{{ formDate.length }}</div>
      <div style="display: flex">
        <div style="margin-right: 15px; color: #30c25b" v-if="info[0].balance > 0">
          历史预缴：{{ returnFloat(info[0].balance) }}元
        </div>
        <div style="margin-right: 15px; color: red" v-if="info[0].balance < 0">
          历史欠费：{{ returnFloat(info[0].balance) }}元
        </div>
        <!-- <div style="margin-right: 15px; color: #30c25b" v-if="surplusAll > 0">
          付款金额：{{ surplusAll }}元
        </div> -->
        <!-- :style=" info[0].calculateBalance > 0 ? 'margin-right:15px;color:green' : 'margin-right:15px;color:red'" -->

        <div
          :style="info[0].balance-sum > 0 ? 'margin-right:15px;color:green' : 'margin-right:15px;color:red'"
        >
          账单金额：{{ returnFloat(sum) }}
        </div>
        <div
          v-if="paymentBillVos.length > 0"
          :style="info[0].calculateBalance > 0 ? 'color:green' : 'color:red'"
        >
          {{ info[0].balance-sum  > 0 ? "对账后结余" : "对账后欠款" }}：{{
            returnFloat(info[0].balance-sum)
          }}
        </div>
      </div>
    </div>
    <div style="margin-top: 20px; text-align: right">
      <el-button type="primary" @click="goDz">开始对账</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ids: [],
      shopRemark: "",
      remark: "",
      sum: 0,
      surplusAll: 0,
      info: [],
      infos: [],
      selectForm: {
        shopNum: null,
        startTime: null,
        endTime: null,
        type: null,
      },
      formDate: [],
      paymentBillVos: [],
    };
  },
  props: {
    obj: {
      type: Object,
      default: {},
    },
  },
  watch: {
    obj: {
      handler(newData, old) {
        // this.shopRemark = JSON.parse(JSON.stringify(newData.shopRemark));
        if (!old) {
          this.shopRemark = JSON.parse(JSON.stringify(newData.shopRemark));
        } else if (newData.shopRemark != old.shopRemark) {
          this.shopRemark = JSON.parse(JSON.stringify(newData.shopRemark));
        }
        let arr = [];
        arr.push(newData);
        this.info = arr;
        // if(this.info[0].isRentalEntry){
        //   this.info[0].historyBalance= this.info[0].balance
        // }
        this.getData2();
        this.getAll();
      },
      immediate: true,
      deep: true,
    },
    paymentBillVos: {
      handler(newData, old) {
        // this.info = [newData]
        console.log(newData);
        this.sum = 0;
        newData.forEach((element) => {
          this.sum = this.sum + element.amount;
        });
      },
    },
  },
  methods: {
    //保留两位小数
    returnFloat(num) {
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") != -1) {
        let newVal = num.split(".");
        if (newVal[1].length == 0) {
          num += ".00";
        } else if (newVal[1].length == 1) {
          newVal = newVal.join(".");
          newVal += "0";
          num = newVal;
        }
        num = Number(num).toFixed(2);
      }
      return num;
    },
    getData(selectForm) {
      this.surplusAll = 0;
      this.ids = [];
      this.infos = [];
      this.$http.post("/api/reconciliation/query", selectForm).then((res) => {
        this.infos = res.data.data.items;
        // this.infos.forEach((element) => {
        //   this.ids.push(element.id)
        //   this.surplusAll = parseFloat(element.surplus) + parseFloat(this.surplusAll);
        // });
      });
    },
    getData2() {
      this.ids = [];
      if (this.info[0].recordId1) {
        this.ids.push(this.info[0].recordId1);
      }
      if (this.info[0].recordId2) {
        this.ids.push(this.info[0].recordId2);
      }
      if (this.info[0].recordId3) {
        this.ids.push(this.info[0].recordId3);
      }
      let selectForm = {
        name: null,
        currentPage: 1,
        pageSize: 10,
        shopNum: this.info[0].shopNum, //商铺号
        id: "", //商铺号
        startTime: this.info[0].appdate, //楼层
        endTime: this.info[0].appdate,
        state: null,
        ids: this.ids.toString(),
      };
      this.getData(selectForm);
    },
    goDz() {
      if (this.paymentBillVos.length == 0) {
        this.$message.error("请选择对账单！");
        return;
      }
      // if (this.sum > this.surplusAll) {
      // 	alert(parseFloat(this.surplusAll) - parseFloat(this.sum))
      // 	this.$message.error("对账金额大于未对账金额！")
      // 	return
      // }
      let id = "";
      if (this.infos[0]) {
        id = this.infos[0].id;
      }
      let balance=this.returnFloat(parseFloat(this.info[0].balance) - parseFloat(this.sum) )
      this.$http
        .post("/api/reconciliation/reconciliation", {
          id: id,
          remark: this.shopRemark,
          paymentBillVos: this.paymentBillVos,
          person: sessionStorage.getItem("name"),
          balance:balance,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
            this.getData2();
            this.$parent.$parent.getAll();
            this.sum = 0;
            this.calculateDifference(this.obj.shopNum);
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    handleSelectionChange(val) {
      this.paymentBillVos = val;
    },
    getAll() {
      this.formDate = [];
      this.$http
        .get("/api/reconciliation/getPaymentBills", {
          params: {
            id: this.info[0].id,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.formDate = res.data.data;
          }
        });
    },
  },
  mounted() {},
};
</script>

<style scoped="scoped"></style>
